import React from 'react';
import PropTypes from 'prop-types';
import 'src/style/vehicleTrackingDuplicacyModal.css';
import { ReactComponent as ExclamationIcon } from 'src/Images/icons/common/exclamation.svg';

function VehicleTrackingDuplicacyModal({
  duplicateData,
  onBack,
  onProceed,
  isProceeding,
  themeColor,
  attemptedVehicleNumber,
}) {
  const matches = Array.isArray(duplicateData?.duplicateObjects)
    ? duplicateData.duplicateObjects
    : [];

  return (
    <div className="vt-duplicacy-modal div-flex-column padding-16 rg-10">
      <div className="div-flex-row align-items-center cg-20">
        <div className="vt-duplicacy-modal__header-icon">
          <ExclamationIcon className="icon-size-xxxl" color="#E7332F" />
        </div>
        <div>
          <span className="text-lg text-semi-bold">
            Vehicle Already in Tracking
          </span>
          <br />
          <span className="text-sm text-grey">
            This vehicle is already being tracked today
          </span>
        </div>
      </div>

      <div className="padding-left-8">
        <span className="text-sm text-bold-500">
          We found the following probable matches
        </span>
        <span className="text-sm text-red">
          {` (${`${matches.length}`.padStart(2, '0')})`}
        </span>
      </div>

      <div
        className={`vt-duplicacy-modal__table-wrapper theme-vertical-scrollable-container-${themeColor}`}
      >
        <div className={`theme-scrollable-container-${themeColor}`}>
          <table className="vt-duplicacy-modal__table">
            <thead>
              <tr>
                <th className="vt-duplicacy-modal__cell--number text-sm text-semi-bold">
                  #
                </th>
                <th>VT Code</th>
                <th>Vehicle Number</th>
                <th>Transporter</th>
                <th>Driver</th>
                <th>Direction</th>
                <th>Workflow Stage</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {matches.length ? (
                matches.map((match, index) => (
                  <tr key={match?.id || index}>
                    <td className="vt-duplicacy-modal__cell--number">
                      {`${(index + 1).toString().padStart(2, '0')}`}
                    </td>
                    <td>{match?.vehicle_tracking_code || '-'}</td>
                    <td>{match?.vehicle_number || '-'}</td>
                    <td>{match?.transporter?.name || '-'}</td>
                    <td>{match?.driver_name || '-'}</td>
                    <td>{match?.direction || '-'}</td>
                    <td>{match?.workflow_stage?.name || '-'}</td>
                    <td>{match?.created || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-sm text-grey">
                    No duplicate records returned by validation.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {!duplicateData?.enforceDuplicateCheckForVehicleTracking && (
        <div className="div-flex-column rg-10 vt-duplicacy-modal__action-card">
          <span className="text-sm">
            Are you sure you want to create tracking for this vehicle?
          </span>
          <div className="div-flex-row align-items-center cg-10 padding-bottom-8">
            <span className="text-md text-semi-bold">
              {attemptedVehicleNumber || '-'}
            </span>
          </div>
        </div>
      )}

      <div className="div-flex-row div-space-between padding-top-8">
        <button
          className={`common-btn-outlined theme-border-color-${themeColor}`}
          onClick={onBack}
          disabled={isProceeding}
          type="button"
        >
          Go back
        </button>
        {!duplicateData?.enforceDuplicateCheckForVehicleTracking && (
          <button
            className={`common-btn theme-background-${themeColor}`}
            onClick={onProceed}
            disabled={isProceeding}
          >
            {isProceeding ? 'Processing...' : 'Proceed anyway'}
          </button>
        )}
      </div>
    </div>
  );
}

VehicleTrackingDuplicacyModal.propTypes = {
  duplicateData: PropTypes.shape({
    duplicateObjects: PropTypes.arrayOf(PropTypes.object),
    vehicleTrackingDataValidity: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.object),
  }),
  onBack: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
  isProceeding: PropTypes.bool,
  themeColor: PropTypes.string.isRequired,
  attemptedVehicleNumber: PropTypes.string,
};

VehicleTrackingDuplicacyModal.defaultProps = {
  duplicateData: null,
  isProceeding: false,
  attemptedVehicleNumber: null,
};

export default VehicleTrackingDuplicacyModal;
